import { render, staticRenderFns } from "./StuckInvoices.vue?vue&type=template&id=2c0ebbe4&"
import script from "./StuckInvoices.vue?vue&type=script&lang=js&"
export * from "./StuckInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports